// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner-container[data-v-af8ee42c]{width:100%;display:flex;align-items:center;justify-content:center;height:100%;padding:20px}.preload-spinner[data-v-af8ee42c]{animation:preload-d2b718e4-af8ee42c 1s linear infinite}@keyframes preload-d2b718e4-af8ee42c{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
